import { clientFetch } from '../clientFetch';

export const newsLetterSubscribe = (body) => {
  return clientFetch(`/newsletter/subscribe`, { method: 'POST', body });
};

export const getSubscriptions = () => {
  return clientFetch(`/user/settings/subscription`);
};

export const updateSubscriptions = (body) => {
  return clientFetch(`/user/settings/subscription`, { method: 'POST', body });
};

export const conditionSubscription = (data) => {
  return clientFetch(`/condition/subscription`, data);
};
